const stoked = {
  prefix: "stoked",
  getValue(key) {
    return document.querySelector(`meta[name='${stoked.prefix}.${key}`)?.content
  }
}

const customizations = {
  prefix: "customizations",
  getValue(key) {
    return stoked.getValue(`${customizations.prefix}.${key}`)
  }
}

export { customizations, stoked };

